import { drupalComponent } from '@nech/src/helpers/drupal-component';

(function (Drupal, $) {
  drupalComponent('gcCardDeputyMember', {
    selector: '.gc--card-deputy-member',

    shared: {
    },

    attach(context, options) {
        const self = this;
        const $el = $(this.selector, context);

        const button = $el.find('a.nech-button');
        const webformOffsetTop = $('#gc--webform-deputy-page').offset()?.top
        const paddingTopWebFormContainer = 32;
        button.on('click', () => {
            if (webformOffsetTop) {
                $('html, body').animate({
                    scrollTop: webformOffsetTop - paddingTopWebFormContainer
                }, 500)
            }
        });
    },

    instance() {

    },
  });
})(Drupal, jQuery);
